import { createReducer, on, Action } from '@ngrx/store';
import { createAction, props } from '@ngrx/store';

// Match interface from master-panel
export interface ColumnConfig {
  field: string;
  visible: boolean;
  sortable: boolean;
  defaultSort?: 'asc' | 'desc';
  sortIndex?: number;
  width?: number;
  minWidth?: number;
  pinned?: 'left' | 'right';
  headerName?: string;
  tooltip?: string;
}

export interface EntityColumnConfigState {
  [entity: string]: ColumnConfig[];
}

// Empty initial state - will be populated by effect from entities metadata
export const initialEntityColumnConfigState: EntityColumnConfigState = {};

// ACTIONS
export const setColumnConfig = createAction(
  '[ColumnConfig] Set Column Config',
  props<{ entity: string; config: ColumnConfig[] }>()
);

export const updateColumnConfig = createAction(
  '[ColumnConfig] Update Column Config',
  props<{ entity: string; updates: Partial<ColumnConfig>[] }>() // must match array order
);

export const resetColumnConfig = createAction(
  '[ColumnConfig] Reset Column Config',
  props<{ entity: string }>()
);

// REDUCER
const entityColumnConfigReducer = createReducer(
  initialEntityColumnConfigState,
  on(setColumnConfig, (state, { entity, config }) => ({
    ...state,
    [entity]: config,
  })),
  on(updateColumnConfig, (state, { entity, updates }) => ({
    ...state,
    [entity]: state[entity]
      ? state[entity].map((col, idx) => ({ ...col, ...(updates[idx] || {}) }))
      : updates as ColumnConfig[],
  }))
  // Note: resetColumnConfig removed since we generate defaults from entities dynamically
);

export function columnConfigReducer(state: EntityColumnConfigState | undefined, action: Action) {
  return entityColumnConfigReducer(state, action);
}
